module.exports = __webpack_public_path__ + "img/China.05102f18.svg";